// CalendarHeader.jsx
import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { format } from "date-fns"; // Import date-fns for formatting

const CalendarHeader = ({
  title,
  onPrevMonth,
  onNextMonth,
  startDate,
  endDate,
}) => {
  // Format the start and end dates if they are provided
  const formattedStartDate = startDate
    ? format(new Date(startDate), "MMM dd, yyyy")
    : "";
  const formattedEndDate = endDate
    ? format(new Date(endDate), "MMM dd, yyyy")
    : "";

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <IconButton onClick={onPrevMonth} aria-label="Previous Month">
        <ArrowBackIcon />
      </IconButton>
      <Box textAlign="center">
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2">
          {formattedStartDate && formattedEndDate
            ? `From: ${formattedStartDate} To: ${formattedEndDate}`
            : ""}
        </Typography>
      </Box>
      <IconButton onClick={onNextMonth} aria-label="Next Month">
        <ArrowForwardIcon />
      </IconButton>
    </Box>
  );
};

export default CalendarHeader;
